<template>
  <v-dialog :model-value="modelValue" max-width="620" @update:model-value="handleModelUpdate">
    <v-card>
      <v-card-title>{{ $t("ncrm.deals.board.lostReasonDialog.title") }}</v-card-title>
      <v-divider />
      <v-card-text>
        <div class="text-body-2 mb-3">
          {{
            $t("ncrm.deals.board.lostReasonDialog.hint", {
              deal: resolvedDealName,
              status: resolvedStatusLabel,
            })
          }}
        </div>
        <v-textarea
          v-model="localReason"
          :label="$t('ncrm.deals.board.lostReasonDialog.reasonLabel')"
          rows="3"
          auto-grow
        />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn variant="text" :disabled="loading" @click="closeDialog">{{ $t("app.actions.cancel") }}</v-btn>
        <v-btn color="primary" :loading="loading" :disabled="saveDisabled" @click="confirmDialog">
          {{ $t("app.actions.save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "NcrmDealLostReasonDialog",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    initialReason: {
      type: String,
      default: "",
    },
    dealName: {
      type: String,
      default: "",
    },
    targetStatusLabel: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue", "confirm", "cancelled"],
  data() {
    return {
      localReason: "",
    };
  },
  computed: {
    resolvedDealName() {
      const label = String(this.dealName || "").trim();
      return label || this.$t("ncrm.deals.board.lostReasonDialog.defaultDealName");
    },
    resolvedStatusLabel() {
      const label = String(this.targetStatusLabel || "").trim();
      return label || this.$t("ncrm.deals.statuses.lost");
    },
    saveDisabled() {
      return this.loading || !String(this.localReason || "").trim();
    },
  },
  watch: {
    modelValue: {
      immediate: true,
      handler(value) {
        if (value) {
          this.localReason = String(this.initialReason || "");
        }
      },
    },
    initialReason(value) {
      if (this.modelValue) {
        this.localReason = String(value || "");
      }
    },
  },
  methods: {
    handleModelUpdate(value) {
      if (value) {
        this.$emit("update:modelValue", true);
        return;
      }
      this.closeDialog();
    },
    closeDialog() {
      this.$emit("update:modelValue", false);
      this.$emit("cancelled");
    },
    confirmDialog() {
      const reason = String(this.localReason || "").trim();
      if (!reason) return;
      this.$emit("confirm", reason);
    },
  },
};
</script>
